import React from 'react';
import { connectWithStore } from '@common/connectWithStore';
import { RootState } from '@redux/types';
import {
  updateCard,
  updateCardCancel,
  getTrace,
  getSupportedCardTypes,
  getIsLoading,
  closeAlert,
  createInstance,
} from '@redux/ducks/paymentMethods';
import {
  PaymentMethod,
  PaymentMethodStateProps,
  PaymentMethodDispatchProps,
  PaymentMethodOwnProps,
} from './PaymentMethod';

const mapStateToProps = (state: RootState): PaymentMethodStateProps => {
  const { isAlertOpen, trace } = getTrace(state);
  const supportedCardTypes = getSupportedCardTypes(state);
  const isLoading = getIsLoading(state);

  return {
    isLoading,
    isAlertOpen,
    trace,
    supportedCardTypes,
  };
};

const mapDispatchToProps: PaymentMethodDispatchProps = {
  init: createInstance,
  onSubmit: updateCard,
  clean: updateCardCancel,
  closeAlert,
};

export const PaymentMethodContainer: React.FC<PaymentMethodOwnProps> = connectWithStore(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentMethod);
